import React from 'react'

import { BaseView } from '@/components/base'
import { Profile, Notifications, InvitationReward, ProfileQRCode } from './components'

interface DashboardHeaderProps {
  onRefresh?: () => Promise<void>
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = () => {
  return (
    <BaseView
      row
      justify="space-between"
      align="center"
      pt={12}
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Profile />
      <BaseView
        row
        align="center"
        gap={21}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '21px',
        }}
      >
        <InvitationReward />
        <Notifications />
        <ProfileQRCode />
      </BaseView>
    </BaseView>
  )
}
